import React from 'react'
import { withProps } from 'recompose'
import { defineMessages, FormattedMessage } from 'react-intl'
import { Format } from '../../..'
import {
  Heading,
  ProConList,
  Pro,
  Info,
} from '../../../shared/Gem/GemDetail'
import { HOMEOWNER_CREDIT_CARD_DEBT_TOPIC_KEY } from '../../../../constants/topicKeys'

const avgCreditCardDebt = 16000

const EliminateCreditCardDebt = props => (
  <div>
    <Heading>
      <FormattedMessage
        id='Homeowner.equity.creditCardDebtHeading'
        defaultMessage='The average American household carries a credit card balance of {debt}. One of the best uses of home equity is paying down this high interest debt.'
        values={{
          debt: <Format.Currency abbreviate value={avgCreditCardDebt} />,
        }}
      />
    </Heading>

    <ProConList>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.creditCardDebtOne'
          defaultMessage='Home equity rates are often substantially lower than those on credit cards'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.creditCardDebtTwo'
          defaultMessage='You can consolidate multiple high-interest balances into a single monthly payment and potentially improve your monthly cash flow'
        />
      </Pro>
      <Info>
        <FormattedMessage
          id='Homeowner.equity.creditCardDebtThree'
          defaultMessage='Because your house is used as collateral, you’ll want a disciplined short-term plan to pay off this debt'
        />
      </Info>
    </ProConList>
  </div>
)

export default {
  GemContainer: withProps({
    qaTag: 'eliminateCreditCardDebtGem',
    amount: avgCreditCardDebt,
  }),
  Detail: EliminateCreditCardDebt,
  ...defineMessages({
    question: {
      id: 'Homeowner.equity.creditCardDebtQuestion',
      defaultMessage: 'How do I pay off my credit cards?',
    },
    topic: {
      id: 'Homeowner.equity.creditCardDebtTopic',
      defaultMessage: 'eliminating credit card debt',
    },
  }),
  topicKey: HOMEOWNER_CREDIT_CARD_DEBT_TOPIC_KEY,
}
